import React from 'react';
import { Card, CardContent, CardMedia, Typography, Box, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { standardCardStyle, cardMediaStyle, cardContentStyle, cardTitleStyle, cardExcerptStyle } from '../../styles/cardStyles';
import dayjs from 'dayjs';

interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  featuredImage: string;  // Can be either a URL or an image key
  publishDate: string;
  authorId: string | any;
  categoryId: string | any;
}

interface BlogPostCardProps {
  post: BlogPost;
}

const BlogPostCard: React.FC<BlogPostCardProps> = ({ post }) => {
  // Determine if the image is a URL or a local asset
  const imageSource = post.featuredImage;

  return (
    <Card sx={standardCardStyle}>
      <CardMedia
        component="img"
        image={imageSource}
        alt={post.title}
        sx={cardMediaStyle}
      />
      <CardContent sx={cardContentStyle}>
        <Box>
          <Typography variant="h6" component="h2" sx={cardTitleStyle}>
            {post.title}
          </Typography>
          <Typography variant="body2" sx={cardExcerptStyle}>
            {post.excerpt}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              {post.categoryId.name} • {dayjs(post.publishDate).format("DD-MM-YYYY")}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              By {post.authorId.username}
            </Typography>
            <Button
              component={RouterLink}
              to={`/posts/${post.id}`}
              variant="contained"
              color="primary"
              size="small"
            >
              Read More
            </Button>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default BlogPostCard; 